import axios from 'axios'
import Cookies from 'js-cookie'
import { API_KEY_LINX } from 'src/util/config'
import { MostPopularWordsResponse } from './dtos'

export const getMostPopularWords =
  async (): Promise<MostPopularWordsResponse> => {
    const deviceId = Cookies.get('nav_id') ?? null

    const { data } = await axios.get<MostPopularWordsResponse>(
      `https://api.linximpulse.com/engage/search/v3/autocompletes/popular?apikey=${API_KEY_LINX}${
        deviceId ? `&deviceId=${deviceId}` : ``
      }`
    )

    return data
  }
